const apiURLs = {
  promotion: {
    basePrefix: 'promotions',
    createPromotion: '',
    getPromotionsList: '',
    setPromotion: (promotionID) => `${promotionID}`,
    getPromotion: (promotionID) => `${promotionID}`,
    enablePromotion: (promotionID) => `${promotionID}/enable`,
    disablePromotion: (promotionID) => `${promotionID}/disable`,
    deletePromotion: (promotionID) => `${promotionID}`,
    searchPromotionCategories: (promotionID) => `${promotionID}/categories/search`,
    setPromotionCategories: (promotionID) => `${promotionID}/categories`,
    setPromotionProducts: (promotionID) => `${promotionID}/products`,
    getPromotionProductsList: (promotionID) => `${promotionID}/products`,
    searchPromotionProducts: (promotionID) => `${promotionID}/products/search`,
    setRibbon:(promotionID,type) => `${promotionID}/ribbons/${type}`,
    deleteRibbon:(promotionID, type) => `${promotionID}/ribbons/${type}`,
    createTimeSlot: (promotionID) => `${promotionID}/slots`,
    deleteTimeSlot: (promotionID, slotID) => `${promotionID}/slots/${slotID}`,
    setTimeSlot: (promotionID) => `${promotionID}/slots`,
  },
  ecwid: {
    basePrefix: '',
    getProfile: 'profile',
  },
  example: {
  },
};

export default apiURLs;
